import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
  },
  label: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#546e7a',
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, 1.5px) scale(1)',
      },
    },
  },
  asterisk: {
    color: '#ef5350',
  },
}));